// Native
import { useEffect, useState } from "react"

// Components
import { Box, Button, ButtonGroup, Center, Divider, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Clipboard, Form, Lottie, Modal, Show } from "components"

// Config
import { API } from "config"

// Screens
import { Authenticate } from "screens"

export default function Password({ data:employee, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ form, setForm ] = useState({})
    const [ loading, setLoading ] = useState(false)
    const [ newPassword, setNewPassword ] = useState()

    const auth = useDisclosure()
    
    const onChange = ({ target }) => {
        const { name, value, checked } = target
        switch(name){
            case 'notify': case 'disconnect': setForm({...form, [name]: checked}); break;
            default: setForm({...form, [name]: value}); break;
        }
    }

    const handleSubmit = async () => {
        setLoading(true)

        try{
            const callback = await API.put(`/employees/${employee.id}/password`, form)
            setNewPassword(callback.data?.password)
            toast({ title: 'A senha foi redefinida', description: 'Você pode copiar a senha e enviar para o cliente.' })
            setForm({})
            onSuccess()
        }catch(err){
            toast({ title: 'Não foi possível redefinir a senha.', description: err?.response?.data?.message })
        }

        setLoading(false)
    }

    useEffect(() => {
        if(!props?.isOpen) setNewPassword(false)
    }, [props?.isOpen])
    
    return(
    <>
    <Modal loading={loading} {...props}>
        <ModalBody>
            <Lottie animation="password" height={150} options={{ loop: false }} style={{ transform: 'scale(1.8)' }} />

            <Stack spacing={6}>
                <Center>
                    <Text fontSize="lg" children="Redefinir senha do funcionário" />
                </Center>

                <Divider />

                <Show visible={!newPassword}>
                    <Form.Form>

                        <Form.Switch
                            label="Desconectar de todas as sessões"
                            name="disconnect"
                            isChecked={form?.disconnect}
                            isDisabled={loading}
                            onChange={onChange}
                        />

                        <Form.Switch
                            label="Enviar nova senha para o e-mail do funcionário"
                            name="notify"
                            isChecked={form?.notify}
                            isDisabled={loading}
                            onChange={onChange}
                        />

                    </Form.Form>
                </Show>

                {/* Exibe a nova senha de autenticação */}
                <Show visible={!!newPassword}>
                    <Text children="Senha redefinida:" />

                    <Clipboard copy={newPassword}>
                        <Box w="100%" textAlign="center" py={4} bgColor="rgba(0,0,0,0.08)" borderRadius={4}>
                            <Text fontSize="2xl" fontWeight="bold" children={newPassword} />
                        </Box>
                    </Clipboard>

                </Show>

            </Stack>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button isDisabled={!!newPassword} isLoading={loading} onClick={auth.onOpen} children="Redefinir senha" />
                <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>

    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}